// extracted by mini-css-extract-plugin
module.exports = {"col":"_2tagC","col-1":"_1t16B","col1":"_1t16B","col-2":"_12tGh","col2":"_12tGh","col-3":"_3hAqT","col3":"_3hAqT"};